_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[64],{

/***/ "/0+H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _ampContext = __webpack_require__("lwAK");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react.default.useContext(_ampContext.AmpStateContext));
}

/***/ }),

/***/ "1P6k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cK8a");


var RowCentered = Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_index_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]).withConfig({
  displayName: "Centered__RowCentered",
  componentId: "sc-11wzwot-0"
})(["justify-content:center;text-align:center;", " ", " ", " @media (min-width:900px){", ";", ";}"], function (props) {
  return props.paddingTop && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["padding-top:", "px;"], props.paddingTop);
}, function (props) {
  return !!props.flexBasis && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["flex-basis:", ";"], props.flexBasis);
}, function (props) {
  return !!props.stepError && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["border:1px solid red;"]);
}, function (props) {
  return props.desktopLeft && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["justify-content:inherit;"]);
}, function (props) {
  return props.desktopWidth && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["width:", "px;"], props.desktopWidth);
});
/* harmony default export */ __webpack_exports__["a"] = (RowCentered);

/***/ }),

/***/ "2qu3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__("lSNA");

var _classCallCheck = __webpack_require__("lwsE");

var _createClass = __webpack_require__("W8MJ");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _useSubscription = __webpack_require__("8L3h");

var _loadableContext = __webpack_require__("jwwS");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
@copyright (c) 2017-present James Kyle <me@thejameskyle.com>
MIT License
Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:
The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE
*/
// https://github.com/jamiebuilds/react-loadable/blob/v5.5.0/src/index.js
// Modified to be compatible with webpack 4 / Next.js


var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };
  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);
      result.promise.then(function (res) {
        state.loaded[key] = res;
      }).catch(function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    state.error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  }).catch(function (err) {
    state.loading = false;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function render(loaded, props) {
  return /*#__PURE__*/_react.default.createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render,
    webpack: null,
    modules: null
  }, options);
  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true && typeof opts.webpack === 'function') {
    var moduleIds = opts.webpack();
    READY_INITIALIZERS.push(function (ids) {
      var _iterator = _createForOfIteratorHelper(moduleIds),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var moduleId = _step.value;

          if (ids.indexOf(moduleId) !== -1) {
            return init();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  }

  var LoadableComponent = function LoadableComponent(props, ref) {
    init();

    var context = _react.default.useContext(_loadableContext.LoadableContext);

    var state = (0, _useSubscription.useSubscription)(subscription);

    _react.default.useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }

    return _react.default.useMemo(function () {
      if (state.loading || state.error) {
        return /*#__PURE__*/_react.default.createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return opts.render(state.loaded, props);
      } else {
        return null;
      }
    }, [props, state]);
  };

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return /*#__PURE__*/_react.default.forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      }).catch(function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _objectSpread(_objectSpread({}, this._state), {}, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks.delete(callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== 'function') {
    throw new Error('LoadableMap requires a `render(loaded, props)` function');
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports.default = _default;

/***/ }),

/***/ "6Kk0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EMPTY_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_USER_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_IS_COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_FINGERPRINT; });
/* unused harmony export SET_NEW_VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return emptyCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return removeCart; });
/* unused harmony export setCart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return setUserGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setIsCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setFingerPrint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return setToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setRefreshToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return logout; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("KQm4");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rePB");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("p46w");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("o75L");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zpb6");



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var ADD_CART = "root/add_cart";
var EMPTY_CART = "root/empty_cart";
var REMOVE_CART = "root/remove_cart";
var SET_CART = "root/set_cart";
var SET_LOCATION = "root/set_location";
var SET_TOKEN = "root/set_token";
var SET_USER_GROUP = "root/set_user_group";
var SET_PERMISSIONS = "root/set_permissions";
var SET_IS_COMPANY = "root/set_is_company";
var SET_FINGERPRINT = "root/set_fingerPrint";
var SET_NEW_VERSION = "root/set_new_version";
var addCart = function addCart(product) {
  return {
    type: ADD_CART,
    payload: _objectSpread({}, product)
  };
};
var emptyCart = function emptyCart() {
  return {
    type: EMPTY_CART
  };
};
var removeCart = function removeCart(id_product) {
  Object(_helpers__WEBPACK_IMPORTED_MODULE_4__[/* fetchAnalytics */ "f"])("cart", {
    event_type: "CART",
    class: "remove",
    meta: {
      productId: id_product
    }
  });
  var remove = {
    type: REMOVE_CART,
    payload: id_product
  };
  return remove;
};
var setCart = function setCart(cart) {
  return {
    type: SET_CART,
    payload: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(cart)
  };
};
var setLocation = function setLocation(location) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: SET_LOCATION,
        payload: _objectSpread({}, location)
      });
      setTimeout(function () {
        resolve();
      }, 30);
    });
  };
};
var setUserGroup = function setUserGroup(user_group) {
  return {
    type: SET_USER_GROUP,
    payload: user_group
  };
};
var setPermissions = function setPermissions(permissions) {
  return {
    type: SET_PERMISSIONS,
    payload: permissions
  };
};
var setIsCompany = function setIsCompany(isCompany) {
  return {
    type: SET_IS_COMPANY,
    payload: isCompany
  };
};
var setFingerPrint = function setFingerPrint(fp) {
  return {
    type: SET_FINGERPRINT,
    payload: fp
  };
};
var setToken = function setToken(token) {
  return function (dispatch) {
    js_cookie__WEBPACK_IMPORTED_MODULE_2___default.a.set("token", token);
    dispatch({
      type: SET_TOKEN,
      payload: token
    });
    dispatch(setPermissions(null));
    dispatch(setIsCompany(null));
    _config_api__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].defaults.headers.Authorization = "Bearer ".concat(token);
  };
};
var setRefreshToken = function setRefreshToken(refreshToken) {
  js_cookie__WEBPACK_IMPORTED_MODULE_2___default.a.set("refreshToken", refreshToken);
};
var logout = function logout() {
  return function (dispatch) {
    js_cookie__WEBPACK_IMPORTED_MODULE_2___default.a.remove("token");
    js_cookie__WEBPACK_IMPORTED_MODULE_2___default.a.remove("refreshToken");
    dispatch(setToken(""));
    dispatch(emptyCart());
    dispatch(setUserGroup(0));
    dispatch(setFingerPrint(null));
  };
};

/***/ }),

/***/ "7W2i":
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__("SksO");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),

/***/ "8Kt/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__("lSNA");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.defaultHead = defaultHead;
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__("q1tI"));

var _sideEffect = _interopRequireDefault(__webpack_require__("Xuae"));

var _ampContext = __webpack_require__("lwAK");

var _headManagerContext = __webpack_require__("FYa8");

var _amp = __webpack_require__("/0+H");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react.default.createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react.default.createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react.default.Fragment) {
    return list.concat(_react.default.Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
returns a function for filtering head child elements
which shouldn't be duplicated, like <title/>
Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if (categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
*
* @param headElements List of multiple <Head> instances
*/


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react.default.Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if (false) { var newProps; }

    return /*#__PURE__*/_react.default.cloneElement(c, {
      key: key
    });
  });
}
/**
* This component injects elements to `<head>` of your page.
* To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
*/


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react.useContext)(_ampContext.AmpStateContext);
  var headManager = (0, _react.useContext)(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react.default.createElement(_sideEffect.default, {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp.isInAmpMode)(ampState)
  }, children);
} // TODO: Remove in the next major release


Head.rewind = function () {};

var _default = Head;
exports.default = _default;

/***/ }),

/***/ "FYa8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HeadManagerContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HeadManagerContext = /*#__PURE__*/_react.default.createContext({});

exports.HeadManagerContext = HeadManagerContext;

if (false) {}

/***/ }),

/***/ "H+hv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useForceUpdate; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable no-plusplus */

function useForceUpdate() {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(0),
      setValue = _useState[1];

  return function () {
    return setValue(function (value) {
      return ++value;
    });
  };
}

/***/ }),

/***/ "M6j1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useEventListener; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useEventListener(eventName, handler, element) {
  var savedHandler = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])();
  var saveElement = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])();
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    savedHandler.current = handler;
  }, [handler]);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    saveElement.current = element;
  }, [element]);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (typeof saveElement.current === "undefined") saveElement.current = window;
    var isSupported = saveElement.current && saveElement.current.addEventListener;
    if (!isSupported) return;

    var eventListener = function eventListener(event) {
      return savedHandler.current(event);
    };

    saveElement.current.addEventListener(eventName, eventListener); // eslint-disable-next-line consistent-return

    return function () {
      saveElement.current.removeEventListener(eventName, eventListener);
    };
  }, [eventName]);
}

/***/ }),

/***/ "Nsbk":
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),

/***/ "OHIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");

var DesktopOnly = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"].div.withConfig({
  displayName: "DesktopOnly",
  componentId: "sc-1onnrlv-0"
})(["display:none;> *{margin:", ";}@media (min-width:900px){", " display:flex;flex-direction:", ";align-items:", ";", ";", ";", ";}"], function (props) {
  return props.childrenMargin ? props.childrenMargin : "0px";
}, function (props) {
  return !!props.flexGrow && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["flex-grow:1;"]);
}, function (props) {
  return props.direction ? props.direction : "column";
}, function (props) {
  return props.align ? props.align : "inherit";
}, function (props) {
  return props.justify && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["justify-content:space-between;"]);
}, function (props) {
  return props.spaceBottom && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["margin-bottom:30px;"]);
}, function (props) {
  return props.spaceTop && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["margin-top:30px;"]);
});
/* harmony default export */ __webpack_exports__["a"] = (DesktopOnly);

/***/ }),

/***/ "PJYZ":
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ "RXBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "__N_SSG", function() { return /* binding */ __N_SSG; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__("Vvt1");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__("g4pe");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./src/hooks/lifecicle/useWaitHydration.js
var useWaitHydration = __webpack_require__("XXxy");

// EXTERNAL MODULE: ./src/requests/sectors.js
var sectors = __webpack_require__("UzFu");

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__("Aiso");
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);

// EXTERNAL MODULE: ./src/atomic/common/Containers/DesktopOnly.js
var DesktopOnly = __webpack_require__("OHIw");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// CONCATENATED MODULE: ./src/atomic/organisms/LandingPage/Background/styles.js

var Image = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Image",
  componentId: "sc-1jllu8a-0"
})(["", " ", " ", " ", " z-index:5;border-radius:10px;overflow:hidden;@media only screen and (max-width:900px){", "}", ""], function (props) {
  return !!props.background && Object(styled_components_browser_esm["a" /* css */])(["background:", ";"], props.background);
}, function (props) {
  return !!props.width && Object(styled_components_browser_esm["a" /* css */])(["width:", ";"], props.width);
}, function (props) {
  return !!props.height && Object(styled_components_browser_esm["a" /* css */])(["height:", ";"], props.height);
}, function (props) {
  return !!props.rotate && Object(styled_components_browser_esm["a" /* css */])(["transform:rotate(", "deg);"], props.rotate);
}, function (props) {
  return !!props.rotateMobile && Object(styled_components_browser_esm["a" /* css */])(["transform:rotate(", "deg);"], props.rotateMobile);
}, function (props) {
  return !!props.breakpoints && props.breakpoints.reduce(function (total, breakpoint) {
    return "".concat(total, "\n            @media only screen and (max-width: ").concat(breakpoint.value, "px) {\n                width: ").concat(breakpoint.width, "px;\n                height: ").concat(breakpoint.height, "px;\n            }\n            ");
  }, "");
});
// EXTERNAL MODULE: ./src/atomic/organisms/LandingPage/styles.js
var styles = __webpack_require__("Vzbl");

// CONCATENATED MODULE: ./src/atomic/organisms/LandingPage/Background/index.js

var __jsx = react_default.a.createElement;





var Background_Background = function Background() {
  return __jsx(react_default.a.Fragment, null, __jsx(DesktopOnly["a" /* default */], null, __jsx(styles["a" /* AbsContainer */], {
    top: "224px",
    left: "20%"
  }, __jsx(Image, {
    background: "rgba(142,179,248,0.09)",
    width: "88px",
    height: "88px",
    rotate: 8.6
  })), __jsx(styles["a" /* AbsContainer */], {
    top: "550px",
    left: "26%"
  }, __jsx(Image, {
    background: "rgba(255,136,136,0.09)",
    width: "55px",
    height: "55px",
    rotate: -32.31
  })), __jsx(styles["a" /* AbsContainer */], {
    top: "30px",
    right: "39%",
    zIndex: 5
  }, __jsx(Image, {
    background: "rgba(255,223,136,0.09)",
    width: "96px",
    height: "96px",
    rotate: 22.39
  })), __jsx(styles["a" /* AbsContainer */], {
    top: "386px",
    right: "14.6%"
  }, __jsx(Image, {
    background: "rgba(46,222,180,0.09)",
    width: "96px",
    height: "96px",
    rotate: -8.06
  })), __jsx(styles["a" /* AbsContainer */], {
    top: "588px",
    right: "23%"
  }, __jsx(Image, {
    background: "rgba(160,136,255,0.09)",
    width: "55px",
    height: "55px",
    rotate: 37.38
  }))), __jsx(styles["a" /* AbsContainer */], {
    top: "320px",
    left: "12%",
    topMobile: "250px",
    leftMobile: "35px",
    transform: "translate(-50%,-50%)",
    zIndex: 5
  }, __jsx(Image, {
    width: "360px",
    height: "495px",
    rotateMobile: -9,
    breakpoints: [{
      value: 1550,
      width: 231,
      height: 315
    }, {
      value: 1320,
      width: 190,
      height: 260
    }, {
      value: 900,
      width: 163,
      height: 225
    }]
  }, __jsx(image_default.a, {
    layout: "fill",
    src: "/images/iphone.png",
    alt: "celular"
  }))), __jsx(styles["a" /* AbsContainer */], {
    top: "50px",
    left: "35.1%",
    topMobile: "8px",
    leftMobile: "75px",
    transform: "translate(-50%,-50%)"
  }, __jsx(Image, {
    width: "675px",
    height: "310px",
    breakpoints: [{
      value: 1550,
      width: 540,
      height: 245
    }, {
      value: 1320,
      width: 459,
      height: 213
    }, {
      value: 900,
      width: 350,
      height: 160
    }]
  }, __jsx(image_default.a, {
    layout: "fill",
    src: "/images/pizza.png",
    alt: "pizza"
  }))), __jsx(styles["a" /* AbsContainer */], {
    top: "-60px",
    right: "0",
    topMobile: "0",
    rightMobile: "150px",
    transformMobile: "translate(100%,-24%)"
  }, __jsx(Image, {
    width: "620px",
    height: "620px",
    breakpoints: [{
      value: 1550,
      width: 490,
      height: 490
    }, {
      value: 1320,
      width: 350,
      height: 350
    }, {
      value: 900,
      width: 320,
      height: 320
    }]
  }, __jsx(image_default.a, {
    layout: "fill",
    src: "/images/shoes.png",
    alt: "tenis"
  }))), __jsx(styles["a" /* AbsContainer */], {
    top: "547px",
    right: "35%",
    topMobile: "150px",
    rightMobile: "-80px",
    transform: "translate(0,-50%)",
    transformMobile: "none"
  }, __jsx(Image, {
    width: "506px",
    height: "480px",
    rotateMobile: 10,
    breakpoints: [{
      value: 1550,
      width: 422,
      height: 400
    }, {
      value: 1320,
      width: 359,
      height: 340
    }, {
      value: 900,
      width: 264,
      height: 250
    }]
  }, __jsx(image_default.a, {
    layout: "fill",
    src: "/images/pillow.png",
    alt: "travesseiro"
  }))));
};

/* harmony default export */ var LandingPage_Background = (Background_Background);
// EXTERNAL MODULE: ./src/hooks/events/useEventListener.js
var useEventListener = __webpack_require__("M6j1");

// EXTERNAL MODULE: ./src/hooks/lifecicle/useForceUpdate.js
var useForceUpdate = __webpack_require__("H+hv");

// EXTERNAL MODULE: ./src/atomic/common/Rows/index.js
var Rows = __webpack_require__("cK8a");

// EXTERNAL MODULE: ./src/atomic/common/Rows/Centered.js
var Centered = __webpack_require__("1P6k");

// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__("40+L");
var react_multi_carousel_default = /*#__PURE__*/__webpack_require__.n(react_multi_carousel);

// CONCATENATED MODULE: ./src/atomic/organisms/LandingPage/Briefing/styles.js


var BriefingContainer = Object(styled_components_browser_esm["b" /* default */])(react_multi_carousel_default.a).withConfig({
  displayName: "styles__BriefingContainer",
  componentId: "nazswu-0"
})(["&&{width:840px;margin:0 auto;padding-bottom:20px;@media only screen and (max-width:1250px){width:554px;}@media only screen and (max-width:900px){width:295px;}.react-multi-carousel-dot--active button{background-color:#1767f5!important;}.react-multi-carousel-dot button{background-color:#cdcdcd;width:7px;height:7px;border:0;}@media only screen and (min-width:1250px){.react-multi-carousel-dot--active button{display:none;}.react-multi-carousel-dot button{display:none;}}}"]);
var BriefingCard = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__BriefingCard",
  componentId: "nazswu-1"
})(["width:268px;height:332px;border:2px solid #F0F5FE;box-sizing:border-box;border-radius:50px;padding:50px 40px 47px;@media only screen and (max-width:900px){width:230px;height:286px;padding:44px 32px;}"]);
var BriefingIcon = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__BriefingIcon",
  componentId: "nazswu-2"
})(["background-color:#F1F5FE;width:62px;height:62px;border-radius:20px;display:flex;flex-direction:column;justify-content:center;align-items:center;@media only screen and (max-width:900px){width:54px;height:54px;}"]);
// CONCATENATED MODULE: ./src/atomic/organisms/LandingPage/Briefing/index.js

var Briefing_jsx = react_default.a.createElement;







var responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1150
    },
    items: 3
  },
  tablet: {
    breakpoint: {
      max: 1250,
      min: 900
    },
    items: 2
  },
  mobile: {
    breakpoint: {
      max: 900,
      min: 0
    },
    items: 1,
    partialVisibilityGutter: 50
  }
};

var Briefing_Briefing = function Briefing() {
  var carousel = Object(react["useRef"])();
  var forceUpdate = Object(useForceUpdate["a" /* default */])();
  var handleResize = Object(react["useCallback"])(function () {
    if (window.innerWidth > 1250 && carousel.current && carousel.current.state.currentSlide !== 0) {
      carousel.current.goToSlide(0);
      forceUpdate();
    }
  }, [carousel, forceUpdate]);
  Object(useEventListener["a" /* default */])("resize", handleResize);
  return Briefing_jsx(react_default.a.Fragment, null, Briefing_jsx(Centered["a" /* default */], {
    paddingDesktopTop: 140,
    paddingTop: 84,
    paddingDesktopBottom: 80,
    paddingBottom: 49
  }, Briefing_jsx(styles["c" /* Title */], {
    width: "70%",
    minWidth: "260px",
    maxWidth: "560px",
    fontSize: 38,
    fontSizeMobile: 28,
    center: true
  }, "Mais r\xE1pido e pr\xE1tico", " ", Briefing_jsx("b", null, "para todos"))), Briefing_jsx(BriefingContainer, {
    ref: carousel,
    responsive: responsive,
    swipeable: true,
    draggable: true,
    showDots: true,
    arrows: false,
    partialVisible: true
  }, Briefing_jsx(BriefingCard, null, Briefing_jsx(Rows["a" /* default */], {
    paddingDesktopBottom: 58,
    paddingBottom: 50
  }, Briefing_jsx(BriefingIcon, null, Briefing_jsx("img", {
    src: "/icons/shopping-cart-blue.svg",
    alt: "icon"
  }))), Briefing_jsx(Rows["a" /* default */], {
    paddingDesktopBottom: 14,
    paddingBottom: 12
  }, Briefing_jsx(styles["c" /* Title */], {
    fontSize: 24,
    fontSizeMobile: 21
  }, "Velocidade na compra e venda")), Briefing_jsx(Rows["a" /* default */], null, Briefing_jsx(styles["b" /* Subtitle */], {
    width: "170px",
    widthMobile: "130px",
    fontSize: 16,
    fontSizeMobile: 14
  }, "Uma forma f\xE1cil e direta de comprar"))), Briefing_jsx(BriefingCard, null, Briefing_jsx(Rows["a" /* default */], {
    paddingDesktopBottom: 58,
    paddingBottom: 50
  }, Briefing_jsx(BriefingIcon, null, Briefing_jsx("img", {
    src: "/icons/home-blue.svg",
    alt: "icon"
  }))), Briefing_jsx(Rows["a" /* default */], {
    paddingDesktopBottom: 14,
    paddingBottom: 12
  }, Briefing_jsx(styles["c" /* Title */], {
    fontSize: 24,
    fontSizeMobile: 21
  }, "Descubra seu bairro")), Briefing_jsx(Rows["a" /* default */], null, Briefing_jsx(styles["b" /* Subtitle */], {
    width: "170px",
    widthMobile: "130px",
    fontSize: 16,
    fontSizeMobile: 14
  }, "Novas lojas e servi\xE7os pr\xF3ximos de voc\xEA"))), Briefing_jsx(BriefingCard, null, Briefing_jsx(Rows["a" /* default */], {
    paddingDesktopBottom: 58,
    paddingBottom: 50
  }, Briefing_jsx(BriefingIcon, null, Briefing_jsx("img", {
    src: "/icons/feather-blue.svg",
    alt: "icon"
  }))), Briefing_jsx(Rows["a" /* default */], {
    paddingDesktopBottom: 14,
    paddingBottom: 12
  }, Briefing_jsx(styles["c" /* Title */], {
    fontSize: 24,
    fontSizeMobile: 21
  }, "Deixe sua loja com a sua cara")), Briefing_jsx(Rows["a" /* default */], null, Briefing_jsx(styles["b" /* Subtitle */], {
    width: "170px",
    widthMobile: "130px",
    fontSize: 16,
    fontSizeMobile: 14
  }, "Personalize sua loja e como ela aparecer\xE1")))));
};

/* harmony default export */ var LandingPage_Briefing = (Briefing_Briefing);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./node_modules/react-geocode/lib/index.js
var lib = __webpack_require__("s3JR");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/helpers/index.js + 24 modules
var helpers = __webpack_require__("zpb6");

// EXTERNAL MODULE: ./src/store/modules/root/actions.js
var actions = __webpack_require__("6Kk0");

// EXTERNAL MODULE: ./src/store/modules/popup_manager/actions.js
var popup_manager_actions = __webpack_require__("pOqu");

// EXTERNAL MODULE: ./src/atomic/common/Buttons/index.js
var Buttons = __webpack_require__("fBnl");

// EXTERNAL MODULE: ./src/atomic/globals/index.js + 3 modules
var globals = __webpack_require__("BlcV");

// CONCATENATED MODULE: ./src/atomic/organisms/LandingPage/SearchBar/styles.js


var SearchContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__SearchContainer",
  componentId: "sc-19lmrbz-0"
})(["position:relative;background-color:white;width:630px;margin-right:20px;border-radius:22px;box-shadow:0px 44px 54px rgba(0,0,0,0.07);padding:0 27px;height:68px;display:flex;align-items:center;& img{margin-right:16px;}@media only screen and (max-width:900px){flex:1;height:48px;border-radius:11px;padding:0 15px;}"]);
var SearchInput = styled_components_browser_esm["b" /* default */].input.withConfig({
  displayName: "styles__SearchInput",
  componentId: "sc-19lmrbz-1"
})(["width:100%;height:100%;border:none;font-family:", ";font-size:18px;&:focus{outline:none;}::placeholder,::webkit-input-placeholder{color:#707070;}:-ms-input-placeholder{color:#707070;}@media only screen and (max-width:900px){font-size:14px;}"], globals["b" /* FONTS */].family.roboto_medium);
var SuggestionsArea = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__SuggestionsArea",
  componentId: "sc-19lmrbz-2"
})(["", " background-color:white;position:absolute;top:105%;left:0;width:100%;border-radius:22px;box-shadow:0px 10px 10px 5px rgba(0,0,0,0.07);.autocomplete-wrapper{display:flex;flex-direction:column;}.autocomplete-wrapper div{cursor:pointer;min-height:50px;margin:5px 0;border-radius:12px;padding:0 10px;display:flex;align-items:center;}.autocomplete-wrapper div:hover{box-shadow:0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);}"], function (props) {
  return !props.open && Object(styled_components_browser_esm["a" /* css */])(["display:none;"]);
});
// CONCATENATED MODULE: ./src/atomic/organisms/LandingPage/SearchBar/index.js



var SearchBar_jsx = react_default.a.createElement;












var DropdownSuggestions = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(14), __webpack_require__.e(35)]).then(__webpack_require__.bind(null, "xkfz"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("xkfz")];
    },
    modules: ["@@/molecules/DropdownSuggestions"]
  }
});

var SearchBar_SearchBar = function SearchBar() {
  var _useState = Object(react["useState"])(""),
      search = _useState[0],
      setSearch = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      processing = _useState2[0],
      setProcessing = _useState2[1];

  var dispatch = Object(es["c" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();

  var submitAddress = /*#__PURE__*/function () {
    var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var address,
          resp,
          _resp$results$0$geome,
          lat,
          lng,
          _args = arguments;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              address = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;

              if (!(!processing && (!!address || !!search))) {
                _context.next = 14;
                break;
              }

              setProcessing(true);
              _context.prev = 3;
              _context.next = 6;
              return lib_default.a.fromAddress(address || search);

            case 6:
              resp = _context.sent;

              if (resp.status === "OK") {
                _resp$results$0$geome = resp.results[0].geometry.location, lat = _resp$results$0$geome.lat, lng = _resp$results$0$geome.lng;
                dispatch(Object(actions["q" /* setLocation */])({
                  address: resp.results[0].formatted_address,
                  latitude: lat,
                  longitude: lng
                }));
                router.push("/busca/localizacao");
              } else {
                setProcessing(false);
                dispatch(Object(popup_manager_actions["g" /* createPopup */])("alert", "Busca inválida", {
                  type: "error"
                }));
              }

              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              setProcessing(false);
              dispatch(Object(popup_manager_actions["g" /* createPopup */])("alert", "Busca inválida", {
                type: "error"
              }));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));

    return function submitAddress() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleAnalytics = function handleAnalytics(value) {
    try {
      Object(helpers["f" /* fetchAnalytics */])("search", {
        event_type: "SEARCH/HOME",
        query: value
      });
    } catch (err) {
      console.log(err);
    }
  };

  var handleSelect = function handleSelect(_ref2) {
    var description = _ref2.description;
    setSearch(description);
    submitAddress(description);
  };

  var handleKeyUp = function handleKeyUp(e) {
    var keyList = ["Shift", "CapsLock", "Control", "Backspace", "Delete"];
    var value = e.target.value;

    if (e.key === "Enter" && !!search) {
      submitAddress();
    } else if (keyList.indexOf(e.key) < 0) {
      handleAnalytics(value);
    }
  };

  return SearchBar_jsx(react_default.a.Fragment, null, SearchBar_jsx(styles["a" /* AbsContainer */], {
    top: "330px",
    left: "50%",
    topMobile: "170px",
    transform: "translate(-50%,-100%)",
    zIndex: 10
  }, SearchBar_jsx(styles["c" /* Title */], {
    minWidth: "345px",
    maxWidth: "900px",
    fontSize: 42,
    fontSizeMobile: 28,
    center: true
  }, "Descubra o com\xE9rcio", " ", SearchBar_jsx("b", null, "dolado"), " ", "de casa")), SearchBar_jsx(styles["a" /* AbsContainer */], {
    width: "825px",
    top: "380px",
    left: "calc(50%)",
    transform: "translate(-50%,0)",
    widthMobile: "calc(100% - 40px)",
    topMobile: "200px",
    leftMobile: "20px",
    transformMobile: "none",
    zIndex: 10
  }, SearchBar_jsx(Rows["a" /* default */], null, SearchBar_jsx(SearchContainer, null, SearchBar_jsx("img", {
    src: "/icons/map-pin.svg",
    alt: "local"
  }), SearchBar_jsx(SearchInput, {
    type: "text",
    placeholder: "Busque por endere\xE7o",
    value: search,
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    },
    onKeyUp: handleKeyUp // onKeyPress={handleKeyPress}

  }), SearchBar_jsx(SuggestionsArea, {
    open: !!search
  }, SearchBar_jsx(DropdownSuggestions, {
    handleSelect: handleSelect,
    open: !!search,
    address: search
  }))), SearchBar_jsx(Buttons["b" /* default */], {
    btnWidth: true,
    btnHeight: 48,
    btnDesktopWidth: 170,
    btnDesktopHeight: 68,
    btnBorderRadius: 17,
    bgColor: "linear-gradient(180deg, #196AF7 0%, #649CFD 0.01%, #196AF7 100%)",
    onClick: function onClick() {
      return submitAddress();
    }
  }, SearchBar_jsx(Buttons["a" /* CustomButtonText */], {
    fontSize: 14,
    fontDesktopSize: 18
  }, "BUSCAR")))));
};

/* harmony default export */ var LandingPage_SearchBar = (SearchBar_SearchBar);
// CONCATENATED MODULE: ./src/atomic/organisms/LandingPage/UsersReport/styles.js


var UsersReportSlider = Object(styled_components_browser_esm["b" /* default */])(react_multi_carousel_default.a).withConfig({
  displayName: "styles__UsersReportSlider",
  componentId: "m13sgf-0"
})(["&&{width:100%;margin:0 auto;padding-bottom:30px;.react-multi-carousel-dot--active button{background-color:#1767f5!important;}.react-multi-carousel-dot button{background-color:#cdcdcd;width:7px;height:7px;border:0;}}"]);
var UserReportCard = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__UserReportCard",
  componentId: "m13sgf-1"
})(["background-color:white;width:620px;height:375px;margin:0 20px;border-radius:50px;box-shadow:0px 14px 54px rgba(0,0,0,0.03);padding:55px 69px;display:flex;flex-direction:column;justify-content:space-between;@media only screen and (max-width:900px){width:350px;height:250px;padding:36px;}"]);
var UserReportIcon = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__UserReportIcon",
  componentId: "m13sgf-2"
})(["background-color:#dddddd;", " background-repeat:no-repeat;background-size:cover;background-position:center;width:64px;height:64px;margin-right:18px;border-radius:32px;overflow:hidden;@media only screen and (max-width:900px){width:43px;height:43px;margin-right:12px;border-radius:21px;}"], function (props) {
  return !!props.src && Object(styled_components_browser_esm["a" /* css */])(["background-image:url(", ");"], props.src);
});
var UserReportInfo = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__UserReportInfo",
  componentId: "m13sgf-3"
})(["display:flex;flex-direction:column;justify-content:space-between;"]);
// CONCATENATED MODULE: ./src/atomic/organisms/LandingPage/UsersReport/index.js

var UsersReport_jsx = react_default.a.createElement;

/* eslint-disable react/no-unescaped-entities */







var UsersReport_responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1924
    },
    items: 3
  },
  tablet1: {
    breakpoint: {
      max: 1924,
      min: 1400
    },
    items: 2,
    partialVisibilityGutter: 60
  },
  tablet2: {
    breakpoint: {
      max: 1400,
      min: 900
    },
    items: 1,
    partialVisibilityGutter: 250
  },
  mobile1: {
    breakpoint: {
      max: 900,
      min: 670
    },
    items: 1,
    partialVisibilityGutter: 300
  },
  mobile2: {
    breakpoint: {
      max: 670,
      min: 460
    },
    items: 1,
    partialVisibilityGutter: 100
  },
  mobile3: {
    breakpoint: {
      max: 460,
      min: 0
    },
    items: 1,
    partialVisibilityGutter: 20
  }
};
var reports = [{
  content: UsersReport_jsx(react_default.a.Fragment, null, "\"Em 26 anos era a primeira vez que n\xE3o via horizonte, (...)", UsersReport_jsx("b", null, " a Dolado me mostrou um horizonte"), ", um caminho para continuar.\""),
  user_icon: "/images/user3.png",
  user_name: "Marcos",
  store: UsersReport_jsx(react_default.a.Fragment, null, "Dono da loja", UsersReport_jsx("b", null, " Siga Cal\xE7ados"))
}, {
  content: UsersReport_jsx(react_default.a.Fragment, null, "\"Talvez muitas pessoas n\xE3o saibam como fazer para divulgar melhor seu servi\xE7o e eu acredito que", UsersReport_jsx("b", null, " a ferramenta Dolado vai auxiliar bastante."), "\""),
  user_icon: "/images/user4.png",
  user_name: "Bruno",
  store: UsersReport_jsx(react_default.a.Fragment, null, "Dono da loja", UsersReport_jsx("b", null, " Brunessa A\xE7a\xED e Cia"))
}, {
  content: UsersReport_jsx(react_default.a.Fragment, null, "\"O nosso bairro \xE9 cheio de coisas boas, coisas que podemos utilizar sem sair da cidade de Tiradentes (...),", UsersReport_jsx("b", null, " a Dolado \xE9 uma \xF3tima iniciativa que eu apoio e super indico!"), "\""),
  user_icon: "/images/user1.png",
  user_name: "Daiane Ferreira",
  store: UsersReport_jsx(react_default.a.Fragment, null, "Dona da loja", UsersReport_jsx("b", null, " Sabor de Pimenta Vermelha"))
}, {
  content: UsersReport_jsx(react_default.a.Fragment, null, "\"", UsersReport_jsx("b", null, "A Dolado est\xE1 me ajudando a ter mais conhecimento"), " ", "com o novo marketing de internet.\""),
  user_icon: "/images/user2.png",
  user_name: "Maria Vanessa",
  store: UsersReport_jsx(react_default.a.Fragment, null, "Dona da loja", UsersReport_jsx("b", null, " VJ Modas"))
}];

var UsersReport_UsersReport = function UsersReport() {
  var carousel = Object(react["useRef"])();
  var forceUpdate = Object(useForceUpdate["a" /* default */])();
  var handleResize = Object(react["useCallback"])(function () {
    if (window.innerWidth > 1400 && window.innerWidth <= 1924) {
      if (carousel.current && carousel.current.state.currentSlide >= 3) {
        carousel.current.goToSlide(2);
        forceUpdate();
      }
    } else if (window.innerWidth > 1924) {
      if (carousel.current && carousel.current.state.currentSlide >= 2) {
        carousel.current.goToSlide(1);
        forceUpdate();
      }
    }
  }, [carousel, forceUpdate]);
  Object(useEventListener["a" /* default */])("resize", handleResize);
  return UsersReport_jsx(react_default.a.Fragment, null, UsersReport_jsx(Centered["a" /* default */], {
    paddingDesktopTop: 130,
    paddingTop: 75,
    paddingDesktopBottom: 64,
    paddingBottom: 24
  }, UsersReport_jsx(styles["c" /* Title */], {
    width: "50%",
    minWidth: "240px",
    maxWidth: "560px",
    fontSize: 38,
    fontSizeMobile: 28,
    center: true
  }, "O que dizem", " ", UsersReport_jsx("b", null, "nossos usu\xE1rios"))), UsersReport_jsx(Rows["a" /* default */], null, UsersReport_jsx(UsersReportSlider, {
    ref: carousel,
    responsive: UsersReport_responsive,
    swipeable: true,
    draggable: true,
    showDots: true,
    arrows: true,
    partialVisible: true
  }, reports.map(function (report, idx) {
    return UsersReport_jsx(UserReportCard, {
      key: idx
    }, UsersReport_jsx(Rows["a" /* default */], null, UsersReport_jsx(styles["c" /* Title */], {
      width: "450px",
      widthMobile: "100%",
      fontSize: 26,
      fontSizeMobile: 17
    }, report.content)), UsersReport_jsx(Rows["a" /* default */], null, UsersReport_jsx(UserReportIcon, {
      src: report.user_icon
    }), UsersReport_jsx(UserReportInfo, null, UsersReport_jsx(styles["c" /* Title */], {
      fontSize: 24,
      fontSizeMobile: 16
    }, report.user_name), UsersReport_jsx(styles["b" /* Subtitle */], {
      fontSize: 18,
      fontSizeMobile: 12
    }, report.store))));
  }))));
};

/* harmony default export */ var LandingPage_UsersReport = (UsersReport_UsersReport);
// CONCATENATED MODULE: ./src/atomic/pages/LandingPage/styles.js

var Container = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Container",
  componentId: "cvgkz7-0"
})(["background-color:#fbfbfb;position:relative;padding-bottom:80px;overflow:hidden;"]);
var NormalPosContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__NormalPosContainer",
  componentId: "cvgkz7-1"
})(["width:100%;margin-top:690px;@media only screen and (max-width:900px){margin-top:400px;}"]);
// CONCATENATED MODULE: ./src/atomic/pages/LandingPage/index.js



var LandingPage_jsx = react_default.a.createElement;











var Categories = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(131)]).then(__webpack_require__.bind(null, "Dp7W"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Dp7W")];
    },
    modules: ["@@/organisms/LandingPage/Categories"]
  }
});
var Neighborhoods = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 138).then(__webpack_require__.bind(null, "/5rO"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("/5rO")];
    },
    modules: ["@@/organisms/LandingPage/Neighborhoods"]
  }
});

var LandingPage_LandingPage = function LandingPage(_ref) {
  var neighborhoods = _ref.neighborhoods;

  var _useState = Object(react["useState"])(null),
      categories = _useState[0],
      setCategories = _useState[1];

  var _coords = Object(es["d" /* useSelector */])(function (state) {
    return state.root.coords;
  });

  var fetchCategories = Object(react["useCallback"])(function () {
    Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _yield$fetchSectors, newCategories;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(sectors["a" /* fetchSectors */])(_coords);

            case 2:
              _yield$fetchSectors = _context.sent;
              newCategories = _yield$fetchSectors.categories;
              setCategories(newCategories.map(function (ctg) {
                return {
                  name: ctg.name,
                  img_src: ctg.icon || "",
                  toPath: "/[category]",
                  asPath: "/".concat(encodeURI(ctg.name))
                };
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [_coords]);
  Object(useWaitHydration["a" /* default */])(fetchCategories);
  return LandingPage_jsx(Container, null, LandingPage_jsx(head_default.a, null, LandingPage_jsx("title", null, "Dolado | Descubra o com\xE9rcio dolado de casa"), LandingPage_jsx("meta", {
    property: "og:title",
    content: "Dolado | Descubra o com\xE9rcio dolado de casa"
  }), LandingPage_jsx("meta", {
    property: "og:url",
    content: "https://compredolado.com.br/"
  }), LandingPage_jsx("meta", {
    name: "description",
    content: "Dolado | Fazer seu Neg\xF3cio Crescer \xE9 Muito Mais F\xE1cil! Mais que uma plataforma de vendas, a Dolado \xE9 um recurso para empreendedores. Buscamos entender necessidades e transform\xE1-las em solu\xE7\xF5es para o dia a dia do lojista."
  }), LandingPage_jsx("meta", {
    property: "og:description",
    content: "Dolado | Fazer seu Neg\xF3cio Crescer \xE9 Muito Mais F\xE1cil! Mais que uma plataforma de vendas, a Dolado \xE9 um recurso para empreendedores. Buscamos entender necessidades e transform\xE1-las em solu\xE7\xF5es para o dia a dia do lojista.",
    key: "ogdesc"
  })), LandingPage_jsx(LandingPage_SearchBar, null), LandingPage_jsx(LandingPage_Background, null), LandingPage_jsx(NormalPosContainer, null, categories && categories.length && LandingPage_jsx(Categories, {
    data: categories
  }), LandingPage_jsx(LandingPage_Briefing, null), LandingPage_jsx(LandingPage_UsersReport, null), neighborhoods && LandingPage_jsx(Neighborhoods, {
    data: neighborhoods
  })));
};

/* harmony default export */ var pages_LandingPage = (LandingPage_LandingPage);
// CONCATENATED MODULE: ./src/pages/index.js

var __N_SSG = true;
/* harmony default export */ var pages = __webpack_exports__["default"] = (pages_LandingPage);

/***/ }),

/***/ "UzFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchSectors; });
/* unused harmony export fetchCountProductsPerSubsectorPerSector */
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("HaE+");
/* harmony import */ var _config_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("o75L");




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


function fetchSectors() {
  return _fetchSectors.apply(this, arguments);
}

function _fetchSectors() {
  _fetchSectors = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee() {
    var _ref,
        latitude,
        longitude,
        urlBack,
        response,
        data,
        categories,
        _args = arguments;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, latitude = _ref.latitude, longitude = _ref.longitude;
            _context.prev = 1;
            urlBack = "/v1/categories";
            if (latitude && longitude) urlBack += "?lat=".concat(latitude, "&lng=").concat(longitude);
            _context.next = 6;
            return _config_api__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get(urlBack);

          case 6:
            response = _context.sent;
            data = response.data;
            categories = [];

            if (response.status === 200) {
              categories = data.categories.map(function (ctg) {
                var temp = _objectSpread({}, ctg);

                if (temp.icon) temp.icon = data.bucket_url + temp.icon;
                if (temp.banner) temp.banner = data.bucket_url + temp.banner;
                return temp;
              });
            }

            return _context.abrupt("return", {
              status: response.status,
              categories: categories
            });

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", {
              status: 500,
              categories: []
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 13]]);
  }));
  return _fetchSectors.apply(this, arguments);
}

function fetchCountProductsPerSubsectorPerSector(_x) {
  return _fetchCountProductsPerSubsectorPerSector.apply(this, arguments);
}

function _fetchCountProductsPerSubsectorPerSector() {
  _fetchCountProductsPerSubsectorPerSector = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(storeId) {
    var response, categories;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return _config_api__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("/v1/products/subcategory/companies/".concat(storeId));

          case 3:
            response = _context2.sent;
            categories = response.data;
            Object.keys(categories).forEach( // eslint-disable-next-line no-return-assign
            function (key) {
              return categories[key] = {
                subcategories: Object.entries(categories[key]).map(function (item) {
                  return item[0];
                }),
                total: Object.entries(categories[key]).map(function (item) {
                  return item[1];
                }).reduce(function (total, item) {
                  return total + item;
                })
              };
            });
            return _context2.abrupt("return", categories);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", []);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));
  return _fetchCountProductsPerSubsectorPerSector.apply(this, arguments);
}

/***/ }),

/***/ "Vvt1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("a6RD")


/***/ }),

/***/ "Vzbl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Subtitle; });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("BlcV");


var AbsContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"].div.withConfig({
  displayName: "styles__AbsContainer",
  componentId: "sc-1dhxijt-0"
})(["position:absolute;", " ", " ", " ", " ", " ", " ", " ", " z-index:", ";@media only screen and (max-width:900px){", " ", " ", " ", " ", " ", "}"], function (props) {
  return !!props.width && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["width:", ";"], props.width);
}, function (props) {
  return !!props.minWidth && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["min-width:", ";"], props.minWidth);
}, function (props) {
  return !!props.maxWidth && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["max-width:", ";"], props.maxWidth);
}, function (props) {
  return !!props.top && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["top:", ";"], props.top);
}, function (props) {
  return !!props.bottom && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["bottom:", ";"], props.bottom);
}, function (props) {
  return !!props.left && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["left:", ";"], props.left);
}, function (props) {
  return !!props.right && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["right:", ";"], props.right);
}, function (props) {
  return !!props.transform && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["transform:", ";"], props.transform);
}, function (props) {
  return props.zIndex ? props.zIndex : 0;
}, function (props) {
  return !!props.widthMobile && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["width:", ";"], props.widthMobile);
}, function (props) {
  return !!props.topMobile && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["top:", ";"], props.topMobile);
}, function (props) {
  return !!props.bottomMobile && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["bottom:", ";"], props.bottomMobile);
}, function (props) {
  return !!props.leftMobile && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["left:", ";"], props.leftMobile);
}, function (props) {
  return !!props.rightMobile && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["right:", ";"], props.rightMobile);
}, function (props) {
  return !!props.transformMobile && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["transform:", ";"], props.transformMobile);
});
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"].h3.withConfig({
  displayName: "styles__Title",
  componentId: "sc-1dhxijt-1"
})(["", " ", " ", " margin:0;color:black;font-family:", ";font-size:", "px;font-weight:normal;", " & b{color:", ";}@media only screen and (max-width:900px){", " ", "}"], function (props) {
  return !!props.width && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["width:", ";"], props.width);
}, function (props) {
  return !!props.minWidth && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["min-width:", ";"], props.minWidth);
}, function (props) {
  return !!props.maxWidth && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["max-width:", ";"], props.maxWidth);
}, _globals__WEBPACK_IMPORTED_MODULE_1__[/* FONTS */ "b"].family.roboto_medium, function (props) {
  return props.fontSize;
}, function (props) {
  return !!props.center && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["text-align:center;"]);
}, _globals__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].primary, function (props) {
  return !!props.widthMobile && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["width:", ";"], props.widthMobile);
}, function (props) {
  return !!props.fontSizeMobile && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["font-size:", "px;"], props.fontSizeMobile);
});
var Subtitle = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"].p.withConfig({
  displayName: "styles__Subtitle",
  componentId: "sc-1dhxijt-2"
})(["", " color:#AAAAAA;font-family:", ";font-size:", "px;& b{color:", ";}@media only screen and (max-width:900px){", " ", "}"], function (props) {
  return !!props.width && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["width:", ";"], props.width);
}, _globals__WEBPACK_IMPORTED_MODULE_1__[/* FONTS */ "b"].family.roboto_regular, function (props) {
  return props.fontSize;
}, _globals__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].primary, function (props) {
  return !!props.widthMobile && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["width:", ";"], props.widthMobile);
}, function (props) {
  return !!props.fontSizeMobile && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["font-size:", "px;"], props.fontSizeMobile);
});

/***/ }),

/***/ "XXxy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useWaitHydration; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("/MKj");


function useWaitHydration(callback) {
  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "root";

  var _hydrated = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useSelector */ "d"])(function (state) {
    return state[reducer].hydrated;
  });

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (_hydrated) callback();
  }, [_hydrated, callback]);
}

/***/ }),

/***/ "Xuae":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray = __webpack_require__("RIqP");

var _classCallCheck = __webpack_require__("lwsE");

var _createClass = __webpack_require__("W8MJ");

var _assertThisInitialized = __webpack_require__("PJYZ");

var _inherits = __webpack_require__("7W2i");

var _possibleConstructorReturn = __webpack_require__("a1gu");

var _getPrototypeOf = __webpack_require__("Nsbk");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

exports.__esModule = true;
exports.default = void 0;

var _react = __webpack_require__("q1tI");

var isServer = false;

var _default = /*#__PURE__*/function (_react$Component) {
  _inherits(_default, _react$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this._hasHeadManager = void 0;

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.delete(this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _default;
}(_react.Component);

exports.default = _default;

/***/ }),

/***/ "a1gu":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("cDf5");

var assertThisInitialized = __webpack_require__("PJYZ");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),

/***/ "a6RD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__("lSNA");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.noSSR = noSSR;
exports.default = dynamic;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _loadable = _interopRequireDefault(__webpack_require__("2qu3"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react.default.createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
} // function dynamic<P = {}, O extends DynamicOptions>(options: O):


function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable.default;
  var loadableOptions = {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), options);

  if (typeof dynamicOptions === 'object' && !(dynamicOptions instanceof Promise)) {
    // show deprecation warning for `modules` key in development
    if (false) {} // Support for `render` when using a mapping, eg: `dynamic({ modules: () => {return {HelloWorld: import('../hello-world')}, render(props, loaded) {} } })


    if (dynamicOptions.render) {
      loadableOptions.render = function (loaded, props) {
        return dynamicOptions.render(props, loaded);
      };
    } // Support for `modules` when using a mapping, eg: `dynamic({ modules: () => {return {HelloWorld: import('../hello-world')}, render(props, loaded) {} } })


    if (dynamicOptions.modules) {
      loadableFn = _loadable.default.Map;
      var loadModules = {};
      var modules = dynamicOptions.modules();
      Object.keys(modules).forEach(function (key) {
        var value = modules[key];

        if (typeof value.then === 'function') {
          loadModules[key] = function () {
            return value.then(function (mod) {
              return mod.default || mod;
            });
          };

          return;
        }

        loadModules[key] = value;
      });
      loadableOptions.loader = loadModules;
    }
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})


  if (typeof loadableOptions.ssr === 'boolean') {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

/***/ }),

/***/ "g4pe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("8Kt/")


/***/ }),

/***/ "jwwS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.LoadableContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LoadableContext = /*#__PURE__*/_react.default.createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ "lwAK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AmpStateContext = /*#__PURE__*/_react.default.createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ "vNVm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("J4zp");

var _interopRequireDefault = __webpack_require__("TqRt");

exports.__esModule = true;
exports.useIntersection = useIntersection;

var _react = __webpack_require__("q1tI");

var _requestIdleCallback = _interopRequireDefault(__webpack_require__("0G5g"));

var hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';

function useIntersection(_ref) {
  var rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;
  var unobserve = (0, _react.useRef)();

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      visible = _ref3[0],
      setVisible = _ref3[1];

  var setRef = (0, _react.useCallback)(function (el) {
    if (unobserve.current) {
      unobserve.current();
      unobserve.current = undefined;
    }

    if (isDisabled || visible) return;

    if (el && el.tagName) {
      unobserve.current = observe(el, function (isVisible) {
        return isVisible && setVisible(isVisible);
      }, {
        rootMargin: rootMargin
      });
    }
  }, [isDisabled, rootMargin, visible]);
  (0, _react.useEffect)(function () {
    if (!hasIntersectionObserver) {
      if (!visible) (0, _requestIdleCallback.default)(function () {
        return setVisible(true);
      });
    }
  }, [visible]);
  return [setRef, visible];
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers.delete(id);
    }
  };
}

var observers = new Map();

function createObserver(options) {
  var id = options.rootMargin || '';
  var instance = observers.get(id);

  if (instance) {
    return instance;
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  observers.set(id, instance = {
    id: id,
    observer: observer,
    elements: elements
  });
  return instance;
}

/***/ }),

/***/ "vlRD":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__("RXBc");
      }
    ]);
  

/***/ })

},[["vlRD",2,1,10,0,4,6,7,9,8,20]]]);